import { render, staticRenderFns } from "./FormularioRuta.vue?vue&type=template&id=55936a27"
import script from "./FormularioRuta.vue?vue&type=script&lang=ts"
export * from "./FormularioRuta.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports